import React from 'react';
import { TaskDashboard } from '../../components/tasks/TaskDashbaord';

export const TaskDashboardPage: React.FC = () => {
  return <TaskDashboard />;
};
